<template>
  <div class="membres" :class="{ marginBandeau: $store.state.bandeau }">
    <LigneTitre>
      <h2>Flash reçus</h2>
      /
      <router-link :to="{ name: 'FlashEnvoyes' }">
        Flash envoyés
      </router-link>
    </LigneTitre>
    <ListeMembres ref="liste" :pattern="pattern" :save="false" :deleteButton="true" @onDelete="onDelete">
      <div>
        Vous n'avez encore reçu aucun Flash.
      </div>
    </ListeMembres>
  </div>
</template>

<script>
import ListeMembres from "@/components/membres/ListeMembres";
import BaseMembres from "@/components/membres/BaseMembres";
import LigneTitre from "@/components/membres/LigneTitre";

import { idyuLoadProfile, idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "Flash",
  components: { ListeMembres, LigneTitre },
  extends: BaseMembres,
  data() {
    return {};
  },

  methods: {
    initPattern: function() {
      this.baseInitPattern();
      this.pattern.flash = true;
      this.alertName = "Flash";
    },

    init: function() {
      this.$super(BaseMembres).init();
      this.$store.state.messager.addAlertListener(this);
    },

    routeEnter: function() {
      this.$counters.newFlashs = 0;
    },

    alertReceived: async function(msg) {
      if (msg.data.type === "flash") {
        const profile = await idyuLoadProfile(msg.data.idFrom);
        this.$refs.liste.resultsList.splice(0, 0, { profile: profile });
      }
    },

    onDelete: async function(result, index) {
      if (await confirm("Voulez-vous supprimer ce flash ?")) {
        await idyuJsonRpc("removeAlert", result.alert.id);
        this.$refs.liste.resultsList.splice(index, 1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/base_membres.scss";
</style>
